import ProductService from '@services/resources/ProductService'
const serviceProduct = ProductService.build()

const state = {
  affiliateFee: null,
  sellerFee: null,
  highTicketFee: null
}
const getters = {
  getAffiliateFee: state => state.affiliateFee,
  getSellerFee: state => state.sellerFee,
  getHighTicketFee: state => state.highTicketFee
}
const mutations = {
  setAffiliateFee(state, value) { state.affiliateFee = value },
  setSellerFee(state, value) { state.sellerFee = value },
  setHighTicketFee(state, value) { state.highTicketFee = value }
}
const actions = {
  updateAffiliateFee({commit}, data) { commit('setAffiliateFee', data) },
  updateSellerFee: ({commit}, data) => commit('setSellerFee', data),
  updateHighTicketFee: ({commit}, data) => commit('setHighTicketFee', data),

  putFees(context, data) {
    return new Promise((resolve, reject) => {
      serviceProduct
        .update(data)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  }
}

export {
  state,
  getters,
  mutations,
  actions
}
